import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faPaperPlane, faTicket } from '@fortawesome/free-solid-svg-icons';
import { faXTwitter, faFacebookF, faInstagram, faYoutube, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import tixbookWhite from "../../assets/images/Tixbook_logo_white.png";
import searchIcon from "../../assets/images/pink-search.svg";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Section */}
      <div className="py-5" style={{ backgroundColor: '#FF1493', color: '#fff' }}>
        <div className="container footerTop">
            <div className="row  justify-content-center align-items-center">
                <div className="col-md-7">
                <h3 className="mb-0 text-white">Have questions? We are just a click away.</h3>
                </div> 
                <div className="col-md-5 text-center">
                <div className="d-flex justify-content-center align-items-center gap-5">
            <div className="text-center">
              <FontAwesomeIcon icon={faHeadset} size="2x" className="mb-2" />
              <p className='text-white mb-0'>Customer Support</p>
              <p className='text-white small email-link'> <a href="mailto:hello@tixbook.com">hello@tixbook.com</a></p>
            </div>
            <div className="text-center d-none">
              <FontAwesomeIcon icon={faTicket} size="2x" className="mb-2" />
              <p className='text-white'>Resend Booking Info</p>
            </div>
          </div>
                </div>
            </div>
         
        
        </div>
      </div>

      {/* Main Footer Section */}
      <div className="py-5" style={{ backgroundColor: '#181E64', color: '#fff' }}>
        <div className="container-fluid container-xxl px-md-5">
          <div className="row d-none">
            {/* Logo and Description */}
            <div className="col-md-4 col-xxl-3">
              <img src={tixbookWhite} className='img-fluid mb-3' alt="tixbookWhite-logo" />
              {/* <p className='text-white'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
            </div>

            {/* Help & Info Section */}
            <div className="col-md-2 offset-md-1">
              <h5 className='text-white'>Help & Info</h5>
              <ul className="list-unstyled">
                <li className='mb-2'><Link to="#">About Us</Link></li>
                <li className='mb-2'><Link to="#">List with Us</Link></li>
                <li className='mb-2'><Link to="/contact-us">Contact Us</Link></li>
                <li className='mb-2'><Link to="#">FAQs</Link></li>
              </ul>
            </div>

            {/* Newsletter Section */}
            <div className="col-md-3 col-8">
              <h5 className='text-white'>Subscribe to Newsletters</h5>
              <form className=" me-3 position-relative newsletter-form w-100">
          <input className="form-control newsletter-bar mt-3" type="search" placeholder="Enter Email" />
          <button className="btn text-primary newsletter-icon" type="submit">
          <FontAwesomeIcon icon={faPaperPlane} />
          </button>
        </form>
            </div>
          </div>

          {/* Bottom Section */}
          {/* <hr style={{ borderColor: '#fff' }} /> */}
          <div className="d-md-flex d-none justify-content-between align-items-center footer-btm">
            <div className="cp-rights d-flex gap-3">
            <img src={tixbookWhite} className='img-fluid' alt="tixbookWhite-logo" />
            {/* <p className="mb-0">Copyright 2025, Tixbook. All rights Reserved.</p> */}
            {/* <p className="mb-0"><Link to="/privacy-policy">Privacy Policy</Link></p>
            <p className="mb-0"><Link to="#">Terms & Conditions</Link></p> */}
            </div>
            
            <div className="cp-rights d-flex gap-3">
            <p className="mb-0 text-white">&copy; 2026, Tixbook. All rights Reserved.</p>
            <p className="mb-0"><Link to="/privacy-policy">Privacy Policy</Link></p>
            <p className="mb-0"><Link to="/terms-and-conditions">Terms & Conditions</Link></p>
              {/* <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a>
              <a href="#"><FontAwesomeIcon icon={faXTwitter} /></a>
              <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="#"><FontAwesomeIcon icon={faYoutube} /></a>
              <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a> */}
            </div>
          </div>
          <div className="d-md-none d-flex justify-content-between align-items-center mt-5 footer-btm">
            <div className="cp-rights d-flex gap-3">
            <p className="mb-0"><Link to="/privacy-policy">Privacy Policy</Link></p>
            <p className="mb-0 pe-0"><Link to="/terms-and-conditions">Terms & Conditions</Link></p>
            </div>
            {/* <div className="d-flex gap-3 social-icons">
              <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a>
              <a href="#"><FontAwesomeIcon icon={faXTwitter} /></a>
              <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="#"><FontAwesomeIcon icon={faYoutube} /></a>
              <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            </div> */}
            <p className="mb-0 mt-5 text-white">&copy; 2026, Tixbook. All rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
